import { enhancedApi } from '.'

export const {
  useBulkCommissionDecommissionChargersMutation,
  useCancelTariffAssociationMutation,
  useCreateServiceEventMutation,
  useDeleteServiceEventMutation,
  useUpdateServiceEventMutation
} = enhancedApi.enhanceEndpoints({
  endpoints: {
    createServiceEvent: {
      invalidatesTags: ['Charger Commissioning Events', 'Chargers']
    },
    deleteServiceEvent: {
      invalidatesTags: ['Charger Commissioning Events', 'Chargers']
    },
    updateServiceEvent: {
      invalidatesTags: ['Charger Commissioning Events', 'Chargers']
    },
    bulkCommissionDecommissionChargers: {
      invalidatesTags: ['Charger Commissioning Events', 'Chargers']
    },
    cancelTariffAssociation: {
      invalidatesTags: ['Sites (Depots)', 'Tariff']
    },
    updateTariffAssociation: {
      invalidatesTags: ['Sites (Depots)', 'Tariff']
    }
  }
})
